import { render } from "./GeneralAnalytics.vue?vue&type=template&id=442d0587&scoped=true"
import script from "./GeneralAnalytics.vue?vue&type=script&lang=js"
export * from "./GeneralAnalytics.vue?vue&type=script&lang=js"

import "./GeneralAnalytics.vue?vue&type=style&index=0&id=442d0587&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442d0587"]])

export default __exports__